
import { defineComponent} from "vue";
    export default defineComponent({
        name: "PdfView",
        methods: {
            goBack(){
                // history.go(-1)
                console.log(history);
                if (history.length > 1) {
                    history.go(-1)
                } else {
                    window.opener = null;
                    window.open("about:blank", "_self");
                    window.close();
                }
            }
        }
    });
